import React from 'react';
import { useHistory } from 'react-router-dom';
import { LayoutHorizontal } from 'components/layouts';
import { Alert, Button, Divider } from 'antd';
import './style.css';

const WorkerWarning = () => {
  const history = useHistory();

  const onSignup = async () => {
    history.push(`/signup/isWorker`);
  };

  return (
    <LayoutHorizontal className="worker-warning-container">
      <div className="content">
        <h3>Please read carefully</h3>
        <br />
        <p>
          To register with MyShifts you will need to upload certain documents to
          enable employers to check your identity and work history. Providing
          the following documents will enable you to become a fully registered
          Worker with MyShifts and begin to receive offers of work or ‘shifts’.
        </p>
        <p>
          Please ensure you have these to hand before you commence the
          registration process, as failure to upload them may result in you not
          being registered and unable to be ‘seen’ by potential employers.
          MyShifts wants all Workers registered on our site to be given an equal
          chance of being ‘contacted’ by an employer to offer you shifts and
          having these documents uploaded will achieve this.
        </p>

        <div className="left">
          <ol>
            <li>Driving Licence (if you have one)</li>
            <li>Passport</li>
            <li>Birth Certificate</li>
            <li>EU or Identity card (if you have one)</li>
            <li>CV</li>
            <li>
              Copies of your latest bills (within last 3 months) to link you
              with the property you live in
            </li>
            <li>Qualifications (if you have any)</li>
            <li>Copies of any ‘training’ certificates</li>
            <li>DBS – last ‘paper’ certificate</li>
          </ol>
        </div>

        <Alert
          className="alert"
          description="All documents can be uploaded in any image format including PDF, JPG and PNG"
          type="info"
          showIcon
        />

        <br />
        <h3>You will need to prove you have the ‘Right to Work’ in the UK</h3>
        <br />
        <p>
          If you do not have an automatic right to work in the UK, then we will
          need proof of your ‘Right to Work’ in the UK. Therefore, in order that
          potential employers comply with the following legislation
        </p>
        <ol>
          <li>Immigration, Asylum and Nationality Act 2006</li>
          <li>Section 24B of the Immigration Act 1971</li>
          <li>Schedule 6 of the Immigration Act 2016</li>
        </ol>

        <p>
          you will need to share details of your right to work in the UK. More
          information on how to do this can be found{' '}
          <a href="https://www.gov.uk/staying-uk-eu-citizen" target="_blank">
            here
          </a>{' '}
          and{' '}
          <a
            href="https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/924360/HO_EUSS_Introduction_to_EUSS_Factsheet.pdf"
            target="_blank"
          >
            here.
          </a>
        </p>

        <p>You’ll also need one of the following:</p>
        <ul>
          <li>your biometric residence permit number</li>
          <li>your biometric residence card number</li>
          <li>your passport or national identity card</li>
        </ul>
        <p>
          If you cannot do this then MyShifts is not able to register you on our
          site.
        </p>

        <Divider />

        <Button type="primary" size="large" onClick={onSignup}>
          Sign Up
        </Button>
      </div>
    </LayoutHorizontal>
  );
};

export default WorkerWarning;
